import {
  OPEN_CHANGE,
  TOASTER_ADD_DANGER,
  TOASTER_ADD_INFO,
  TOASTER_ADD_SUCCESS,
  TOASTER_ADD_WARNING,
  TOASTER_HIDE,
  TOASTER_READ,
  TOASTER_REMOVE,
  TOASTER_REMOVE_ALL,
} from './constants';

export function readNotifications() {
  return {
    type: TOASTER_READ,
  };
}

export function removeAllNotifications() {
  return {
    type: TOASTER_REMOVE_ALL,
  };
}

export function removeNotification(key) {
  return {
    type: TOASTER_REMOVE,
    payload: {
      key,
    },
  };
}

export function hideNotification({ hash, read }) {
  return {
    type: TOASTER_HIDE,
    payload: {
      hash,
      read,
    },
  };
}

export function showSuccess(payload) {
  return {
    type: TOASTER_ADD_SUCCESS,
    payload,
  };
}

export function showInfo(payload) {
  return {
    type: TOASTER_ADD_INFO,
    payload,
  };
}

export function showWarning(payload) {
  return {
    type: TOASTER_ADD_WARNING,
    payload,
  };
}

export function showDanger(payload) {
  return {
    type: TOASTER_ADD_DANGER,
    payload,
  };
}

export function openChange(args) {
  return {
    type: OPEN_CHANGE,
    payload: args,
  };
}
